<template>
 <div>
   <div ref="searchBox">
     <div class="detailsTitle">
        <h4>查询结果</h4>
        <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
     <div class="searchBox"  v-if="searchFrom.likeGoods||searchFrom.startArea||searchFrom.endArea||searchFrom.activeDates.length>0">
      <el-form :inline="true"  class="demo-form-inline" label-width="80" size="mini">
            <el-form-item label="货物类型:" prop="likeGoods" v-if="searchFrom.likeGoods" >
              <div style="margin-right:30px">{{searchFrom.likeGoods}}</div>
            </el-form-item>
            <el-form-item label="运输路线:" prop="startArea"  v-if="searchFrom.startArea||searchFrom.endArea">
              <span>{{searchFrom.startArea}}<i class="fa fa-arrows-h" aria-hidden="true"></i>{{searchFrom.endArea}}</span>
            </el-form-item>
            <el-form-item label="最近活跃日期:" prop="startArea"  v-if="searchFrom.activeDates.length>0">
              <span>{{searchFrom.activeDates[0]}}至{{searchFrom.activeDates[1]}}</span>
            </el-form-item>
      </el-form>
    </div>
   </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="004P003B002"  @click="lookFN(scope.row)">查看详情</el-button>
            </template>
        </el-table-column>
         <el-table-column label="司机姓名"  width="100">
            <template slot-scope="scope">
              <span>{{scope.row.name.slice(0,1)}}师傅</span>
            </template>
        </el-table-column>
        <el-table-column prop="likeGoods"  min-width="200" :formatter="emptyFn" label="货物类型"></el-table-column>
        <el-table-column label="联系电话"  width="150">
            <template slot-scope="scope">
              <span>{{scope.row.mobile.replace(/^(.{3})(?:\w+)(.{4})$/, "\$1****\$2")}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="oftenRoute" :formatter="emptyFn" min-width="300" label="运输路线"></el-table-column>
        <el-table-column prop="wayNum" min-width="120" :formatter="emptyFn" label="接单量(单)"></el-table-column>
        <!-- <el-table-column prop="averagePrice"  min-width="150" :formatter="emptyFn" label="业务均价(元/吨)"></el-table-column> -->
        <el-table-column prop="monthNum" width="120"   label="当月查询次数"></el-table-column>
        <el-table-column prop="allNum" width="120"   label="累计查询次数"></el-table-column>
        <el-table-column prop="activeDate" width="170" :formatter="dateFormat"  label="最近活跃日期"></el-table-column>
        <el-table-column prop="auditTime" width="170" :formatter="dateTimeFormat"  label="入驻时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 驾驶车辆 -->
    <el-dialog  title="详细信息"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="800" center>
      <span>
           <el-form :inline="true"  class="demo-form-inline" label-width="80" size="mini">
            <el-form-item label="司机姓名:"  >
              <div style="margin-right:30px">{{addFrom.name}}</div>
            </el-form-item>
            <el-form-item label="联系电话:" >
              <div  style="margin-right:30px">{{addFrom.mobile}}</div>
            </el-form-item>
            <!-- <el-form-item label="业务均价:" >
              <div>{{addFrom.averagePrice}}元/吨</div>
            </el-form-item> -->
          </el-form>
          <hr>
          <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>运输路线</span>
              </h4>
              <div>
                  <el-table :data="haulway" ref="table" v-loading="loading" bordersize="mini"
                    class="table" height="270px" style="width: 100%"   center  border   >
                  <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
                  <el-table-column  :formatter="emptyFn"  label="路线">
                     <template scope="scope">
                      <div>{{scope.row.deliverAddress}} <===> {{scope.row.receivingAddress}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="wayNum"  width="120" :formatter="emptyFn" label="接单量(单)"></el-table-column>
                  <el-table-column prop="averagePrice" :formatter="emptyFn" label="业务均价"  width="150">
                    <template scope="scope">
                      <div>{{scope.row.averagePrice}}元/吨</div>
                    </template>
                  </el-table-column>
                  </el-table-column>
                  </el-table>
                  <p style="color:red">备注：最多展示5条司机运输路线</p>
              </div>
          </div>
          <hr>
          <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>驾驶车辆</span>
              </h4>
              <div>
                  <el-table :data="carList" ref="table" v-loading="loading" bordersize="mini"
                    class="table" height="380px" style="width: 100%"   center  border   >
                  <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
                  <el-table-column prop="vhcNo"  width="160" label="车牌号"></el-table-column>
                  <el-table-column prop="vhcTypeName"  width="160" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
                  <el-table-column prop="vhcLongName" :formatter="emptyFn" label="外廓尺寸"></el-table-column>
                  <el-table-column prop="weight" width="200"  :show-overflow-tooltip="true" :formatter="emptyFn" label="载重(吨)"></el-table-column>
                </el-table>
              </div>
            </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { driverFound, getCVehicleInfoListByDriverId, tenantDriverLogDetail } from '@/api/vgs-driver2.0'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  data () {
    let searchFrom = JSON.parse(this.$route.query.from)
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      haulway: [],
      carList: [],
      searchFrom: searchFrom,
      total: 0,
      loading: 'false',
      goodTypes: [],
      addFrom: {}
    }
  },
  created () {
    if (!this.searchFrom.activeDates) {
      this.searchFrom.activeDates = []
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'

    this.searchFrom.likeGoods = this.searchFrom.likeGoodsArr.toString()
    this.getList(this.searchFrom)
  },
  methods: {
    // 查看
    lookFN (row) {
      getCVehicleInfoListByDriverId({ driverId: row.id }).then(res => {
        tenantDriverLogDetail({ driverId: row.id }).then(res1 => {
          this.addFrom = row
          this.dialogVisible = true
          this.carList = res
          this.haulway = res1.list
          this.getList(this.searchFrom)
        })
      })
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      driverFound(searchFrom).then(res => {
        this.loading = false
        if (res) {
          this.tableList = res.list
          this.total = res.total
        }
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        likeGoodsArr: [],
        activeDates: null,
        auditTimes: null
      }
    },

    closeDialog () {
      this.addFrom = {}
      this.flag = false
    }
  },
  inject: ['reload'],
  beforeRouteEnter (to, from, next) {
    to.meta.keepAlive = true
    if (from.path !== '/SzhaoChe/list') {
      next(vm => {
        vm.reload()
      })
    } else {
      next()
    }
  },
  beforeRouteLeave  (to, from, next) {
    if (to.path == '/SzhaoChe/list') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
}
</script>

<style scoped lang='less'>
.searchBox{
    background: #bde2f3;
    padding: 16px;
    margin: 12px;
    margin-top: 0;
}
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.fa-arrows-h{
      margin: 0 4px;
}
</style>
